import { defineAsyncComponent } from 'vue'

export const batchTabs = [
  {
    key: 'clients',
    label: 'Clients',
    component: defineAsyncComponent(() =>
      import('@/components/entries/clientbatch.vue')
    )
  },
  {
    key: 'accounts',
    label: 'Accounts',
    component: defineAsyncComponent(() =>
      import('@/components/entries/accountbatch.vue')
    )
  },
    {
    key: 'clientaccounts',
    label: 'Members OB',
    component: defineAsyncComponent(() =>
      import('@/components/entries/clientsob.vue')
    )
  },
      {
    key: 'clientlbs',
    label: 'Members LB',
    component: defineAsyncComponent(() =>
      import('@/components/entries/clientslbs.vue')
    )
  },
  // {
  //   key: 'save',
  //   label: 'Savings',
  //   component: defineAsyncComponent(() =>
  //     import('@/components/entries/savebatch.vue')
  //   )
  // },
    {
    key: 'deductions',
    label: 'Update-Deductions',
    component: defineAsyncComponent(() =>
      import('@/components/entries/updatedeductions.vue')
    )
  },
]
